if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        setTimeout(() => {
  this.filterCasecraftMedia();
}, 0);

        if (!this.elements.thumbnails) return;
        this.prependMedia = this.dataset.disablePrepend != 'true';      
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
filterCasecraftMedia(selectedMediaId) {
  const dataElement = this.querySelector('.casecraft-gallery-data');
  if (!dataElement) return;

  let data;
  try {
    data = JSON.parse(dataElement.textContent);
  } catch (error) {
    console.warn('CaseCraft: invalid gallery data', error);
    return;
  }

  const variants = data.variants || [];
  const media = data.media || [];
  const initialVariant = variants.find(
    (variant) => String(variant.id) === String(data.selectedVariantId)
  );

  const selectedVariant = selectedMediaId
    ? variants.find(
        (variant) =>
          variant.mediaId &&
          selectedMediaId.endsWith('-' + variant.mediaId)
      )
    : initialVariant;

  if (!selectedVariant || !selectedVariant.mediaId) return;

  const normalize = (value) =>
    String(value || '').trim().toLowerCase();

  const options = selectedVariant.options.map(normalize);

  const matchingImages = media.filter((image) => {
    const parts = String(image.alt || '')
      .split('—')
      .map(normalize);

    return (
      parts.length >= 4 &&
      options.length === 2 &&
      parts[1] === options[0] &&
      parts[2] === options[1]
    );
  });

  const mainId = String(selectedVariant.mediaId);
  const additionalIds = matchingImages
    .map((image) => String(image.id))
    .filter((id) => id !== mainId)
    .slice(0, 3);

  const filtering = additionalIds.length > 0;
  const visibleIds = new Set([mainId, ...additionalIds]);

  const updateItem = (element, visible) => {
    if (!element.hasAttribute('data-casecraft-original-style')) {
      element.setAttribute(
        'data-casecraft-original-style',
        element.getAttribute('style') || ''
      );
    }

    if (!filtering) {
      const originalStyle = element.getAttribute(
        'data-casecraft-original-style'
      );
      if (originalStyle) {
        element.setAttribute('style', originalStyle);
      } else {
        element.removeAttribute('style');
      }
      return;
    }

    element.style.setProperty(
      'display',
      visible ? 'block' : 'none',
      'important'
    );
  };

  this.elements.viewer
    .querySelectorAll('[data-media-id]')
    .forEach((element) => {
      const id = element.dataset.mediaId.split('-').pop();
      updateItem(element, visibleIds.has(id));
    });

  if (this.elements.thumbnails) {
    this.elements.thumbnails
      .querySelectorAll('[data-target]')
      .forEach((element) => {
        const id = element.dataset.target.split('-').pop();
        updateItem(element, visibleIds.has(id));

      });
  }

  this.elements.viewer.resetPages?.();
  this.elements.thumbnails?.resetPages?.();
}

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (prepend) {
  this.filterCasecraftMedia(mediaId);
}
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend && this.prependMedia) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({
  left: activeMedia.offsetLeft,
  behavior: 'instant'
});

          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({
  behavior: 'instant',
  block: 'nearest',
  inline: 'nearest'
});

          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        
        if ( activeMedia.querySelector('.internal-video--playing video')) {
          activeMedia.querySelector('video').play();

        }
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
  this.announceLiveRegion(
    activeMedia,
    activeThumbnail.dataset.mediaPosition
  );
}

      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
  left: thumbnail.offsetLeft,
  behavior: 'instant'
});

      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
